import { Dispatch, SetStateAction, createContext, useContext } from "react";

export const SortContext = createContext<
  [string, Dispatch<SetStateAction<string>>]
>([
  "",
  () => {
    /* noop */
  },
]);

export const useSort = () => useContext(SortContext);
